module.exports = __webpack_public_path__ + "img/google-my-business.f9a46dfc.png";